module.exports = __webpack_public_path__ + "assets/materialdesignicons-webfont.fe1545ef4dd1eef2f1e25528898fc0b3.ttf";